import { TRootState }    from 'Redux/Reducers';
import { arrayContains } from 'Utils';
import Actions           from 'Redux/Actions';

export const isLocationLoading = (state: TRootState): boolean =>
  arrayContains(state.location.openRequests, [
    Actions.findLocationRequest.type,
    Actions.findLocationsRequest.type,
    Actions.createLocationRequest.type,
    Actions.updateLocationRequest.type,
    Actions.deleteLocationRequest.type,
  ]);
